<template>
  <div class="navbar navbar-default">
    <div class="container">
      <router-link class="navbar-brand" to="/home">
        <img src="../../../assets/logo.svg" />
      </router-link>

      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" @click="open = !open">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>

      <div class="navbar-collapse" :class="{ collapse: !open }">
        <ul class="nav navbar-nav navbar-center">
          <li><router-link to="/solar-battery" active-class="active" target="_blank">Solar & Battery</router-link></li>
          <li><router-link to="/electric-vehicle" active-class="active" target="_blank">Electric Vehicle</router-link>
          </li>
          <li><router-link to="/heat-pump" active-class="active" target="_blank">Heat Pump</router-link></li>
        </ul>
      </div><!-- /.navbar-collapse -->
    </div>

    <div class="contact">
      <contact-us />
    </div>
  </div>
</template>

<script>
import ContactUs from '@/components/contact-us/ContactUs';

export default {
  name: 'NavigationBar',
  data() {
    return {
      open: false
    };
  },
  components: {
    ContactUs
  }
};
</script>

<style lang="scss" src="./navigation-bar.scss"></style>
